import {
  GET_ALL_BANK_ACCOUNTS_FAIL,
  GET_ALL_BANK_ACCOUNTS_REQUEST,
  GET_ALL_BANK_ACCOUNTS_SUCCESS,
  CREATE_BANK_ACCOUNT_FAIL,
  CREATE_BANK_ACCOUNT_REQUEST,
  CREATE_BANK_ACCOUNT_SUCCESS,
  EDIT_BANK_ACCOUNT_FAIL,
  EDIT_BANK_ACCOUNT_REQUEST,
  EDIT_BANK_ACCOUNT_SUCCESS,
} from "../../types/admin/bankAccount";


export const getAllBankAccountsReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_ALL_BANK_ACCOUNTS_REQUEST:
        return {
          ...state,
          getAllBankAccountsLoading: true,
        };
      case GET_ALL_BANK_ACCOUNTS_SUCCESS:
        return {
          ...state,
          getAllBankAccountsLoading: false,
          getAllBankAccountsInfo: payload,
          getAllBankAccountsErrors: "",
        };
      case GET_ALL_BANK_ACCOUNTS_FAIL:
        return {
          ...state,
          getAllBankAccountsLoading: false,
          getAllBankAccountsErrors: payload,
          getAllBankAccountsInfo: [],
        };
      default:
        return state;
    }
  };
  

export const createBankAccountReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case CREATE_BANK_ACCOUNT_REQUEST:
        return {
          ...state,
          createBankAccountLoading: true,
        };
      case CREATE_BANK_ACCOUNT_SUCCESS:
        return {
          ...state,
          createBankAccountLoading: false,
          createBankAccountInfo: payload,
          createBankAccountErrors: "",
        };
      case CREATE_BANK_ACCOUNT_FAIL:
        return {
          ...state,
          createBankAccountLoading: false,
          createBankAccountErrors: payload,
          createBankAccountInfo: [],
        };
      default:
        return state;
    }
  };
  

export const editBankAccountReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case EDIT_BANK_ACCOUNT_REQUEST:
        return {
          ...state,
          editBankAccountLoading: true,
        };
      case EDIT_BANK_ACCOUNT_SUCCESS:
        return {
          ...state,
          editBankAccountLoading: false,
          editBankAccountInfo: payload,
          editBankAccountErrors: "",
        };
      case EDIT_BANK_ACCOUNT_FAIL:
        return {
          ...state,
          editBankAccountLoading: false,
          editBankAccountErrors: payload,
          editBankAccountInfo: [],
        };
      default:
        return state;
    }
  };
  